// Constants for different requests for current reducer
export default {
  tsByClient: 'TS_BY_CLIENT',
};
